import { brokersFieldLimits } from "@/Shared/Brokers/Helpers/brokersFieldLimits";
import ContactsLargeContactInput from "@/Shared/Contacts/Inputs/ContactsLargeContactInput";
import {
  EmailRequired,
  contactsErrorMessagesForContact,
} from "@/Shared/Contacts/Validators/contactsErrorMessagesForContact";
import type { Contact } from "@freightsimple/generated-dashboard-openapi-client/models/Contact";
import { useState } from "react";
import type { AddContactContactType } from "@/Shared/Types/contactTypes";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";

interface ModifyBrokerDialogContactPageProps {
  contact: Contact;
  contactChanged: (_: AddContactContactType) => void;
  onDone: () => void;
  onPrevious: () => void;
}

function BrokersModifyBrokerDialogContactPage(
  props: ModifyBrokerDialogContactPageProps,
) {
  const { contact, contactChanged, onDone, onPrevious } = props;
  const [forceValidation, setForceValidation] = useState(false);
  const errorMessages = contactsErrorMessagesForContact(
    contact,
    EmailRequired.EmailRequired,
  );

  function updateContact(contactUpdates: AddContactContactType) {
    contactChanged(contactUpdates);
  }

  function isValid() {
    if (
      errorMessages.contactName ||
      errorMessages.emailAddress ||
      errorMessages.phoneNumber
    ) {
      return false;
    } else {
      return true;
    }
  }

  async function onNext() {
    if (isValid()) {
      onDone();
    } else {
      setForceValidation(true);
    }
  }

  return (
    <Stack gap={8}>
      <ContactsLargeContactInput
        contact={contact}
        contactChanged={updateContact}
        forceValidation={forceValidation}
        errorMessages={errorMessages}
        maxLengths={brokersFieldLimits}
      ></ContactsLargeContactInput>
      <Row justify="between">
        <Button onClick={onPrevious}>Previous</Button>
        <Button primary data-testid="save-broker-button" onClick={onNext}>
          Save
        </Button>
      </Row>
    </Stack>
  );
}

export default BrokersModifyBrokerDialogContactPage;
